/* eslint-disable */
import { createReducer, createActions } from "reduxsauce"
import Immutable from "seamless-immutable"

/* ------------- Types and Action Creators ------------- */

const { Types, Creators } = createActions({
  shopGetConfig: [],
  shopSearchItems: ['search', 'start', 'limit', 'filter', 'options'], // live 't shirt' fix, do not show iSells
  shopGetItems: ['itemIds'],
  shopGetVariants: ['itemId'],
  shopStateChange: ['changes'],
  shopCreateCartWithItem: ['user', 'post', 'tag', 'item', 'variant'],
  shopSetCheckoutUrl: ['url'],
})

export const ShoppableTypes = Types
export default Creators

/* ------------- Initial State ------------- */

export const INITIAL_STATE = Immutable({
  config: {
    modified: null,
    fetching: false,
    error: null,
    headers: null,
    default: null,
    data: null,
  },
  items: {
    modified: null,
    fetching: false,
    error: null,
    start: 0,
    limit: 100,
    source: 'kargoe',
    kargoeRead: 0,
    search: '',
    list: [],
  },
  selectedItems: {
    modified: null,
    fetching: false,
    error: null,
    list: [],
  },
  variants: {
    modified: null,
    fetching: false,
    error: null,
    itemId: null,
    data: null,
  },
  cart: {
    modified: null,
    fetching: false,
    error: null,
    cartId: null,
    userId: null,
    post: null,
    content: [], // .item and .variant, see item.ItemId and variant.id, prep for multiple items in shopping cart
  },
  checkout: {
    modified: null,
    url: null,
    error: null,
  },
})

/* ------------- Reducers ------------- */

export const shopGetConfig = (state, action) => {
  console.tron.display({
    name: 'shopGetConfig',
    preview: 'ShoppableRedux',
    value: {
      action: action,
    }
  })
  if (state.config.itemCount == 0 || state.config.error || Date.now() - state.config.modified > 3600000)  // every hour 3600000  every minute 60000
    return state.merge({
      config: {
        fetching: true,
        error: null,
      }
    })
  else
    return state
}

export const shopSearchItems = (state, action) => {
  console.tron.display({
    name: 'shopSearchItems',
    preview: 'ShoppableRedux',
    value: {
      action: action,
    }
  })
  const { start = 0, limit = 100, search, filter } = action // start with zero or one?
  return state.merge(state.items, {
    items: {
      fetching: true,
      error: null,
/*
      start,
      limit,
      search,
      filter,
*/      
      // list: [], // so we don't have flickering for each character typed
    }
  })
}

export const shopGetItems = (state, action) => {
  console.tron.display({
    name: 'shopGetItems',
    preview: 'ShoppableRedux',
    value: {
      action: action,
    }
  })
  const { itemIds } = action
  return state.merge(state.selectedItems, {
    selectedItems: {
      fetching: true,
      error: null,
      list: [],
    }
  })
}

export const shopGetVariants = (state, action) => {
  console.tron.display({
    name: 'shopGetVariants',
    preview: 'ShoppableRedux',
    value: {
      stateVariants: state.variants,
      action: action,
    }
  })
  const { itemId } = action
  if (state.variants.itemId == itemId && state.variants.data != null) {
    console.tron.log(`already have variant data for ${itemId}`)
    // do not bother fetching a second time
    return state.merge({
      cart: {
        fetching: true,
        modified: null,
        error: null,
        cartId: null,
        userId: null,
        content: [],
      }
    })
  }
  else
    return state.merge({
      variants: {
        itemId: itemId,
        fetching: true,
        error: null,
        data: null,
      },
      cart: {
        fetching: false,
        modified: null,
        error: null,
        cartId: null,
        userId: null,
        content: [],
      }
    })
}

export const shopCreateCartWithItem = (state, action) => {
  console.tron.display({
    name: 'shopCreateCartWithItem',
    preview: 'ShoppableRedux',
    value: {
      stateCart: state.cart,
      action: action,
    }
  })
  const { user, post, tag, item, variant } = action
  if (state.cart.content.length && state.cart.content[0].variant.id == variant.id) {
    console.tron.log(`already purchased variant ${variant.id}`)
    return state.merge({cart: state.cart}, {
      cart: {
        error: "This item has already been purchased"
      }
    })
  }
  else
    return state.merge({cart: state.cart}, {
      cart: {
        fetching: true,
        error: null,
        cartId: null,
        userId: null,
        post: null,
        content: [],
      }
    })
}

export const shopSetCheckoutUrl = (state, action) => {
  return state
} // shopSetCheckoutUrl

export const stateChange = (state, action) => {
  console.tron.display({
    name: 'stateChange',
    preview: 'shoppableRedux',
    value: {
      action: action,
    }
  })
  const { changes } = action
  return state.merge(changes)
}

/* ------------- Hookup Reducers To Types ------------- */

export const reducer = createReducer(INITIAL_STATE, {
  [Types.SHOP_GET_CONFIG]:   shopGetConfig,
  [Types.SHOP_SEARCH_ITEMS]: shopSearchItems,
  [Types.SHOP_GET_ITEMS]:    shopGetItems,
  [Types.SHOP_GET_VARIANTS]: shopGetVariants,
  [Types.SHOP_STATE_CHANGE]: stateChange,
  [Types.SHOP_CREATE_CART_WITH_ITEM]: shopCreateCartWithItem,
  [Types.SHOP_SET_CHECKOUT_URL]: shopSetCheckoutUrl,
})
